module.exports = __webpack_public_path__ + "static/media/icon-manage-class-student-list-link.83905d60.svg";